const PersonalShopperIcon = () => {
  //  width = '22';
  //  height = '22';
  //  viewBox = '0 0 22 22';
  return (
    <path
      id='Vector'
      d='M19.6964 8.39079H15.5312L11.7138 2.67775C11.366 2.16471 10.6095 2.16471 10.2703 2.67775L6.45294 8.39079H2.30511C1.82685 8.39079 1.43555 8.7821 1.43555 9.26036C1.43555 9.33862 1.44424 9.41688 1.47033 9.49514L3.67902 17.556C3.87902 18.2864 4.54859 18.8256 5.34859 18.8256H16.6529C17.4529 18.8256 18.1225 18.2864 18.3312 17.556L20.5399 9.49514L20.566 9.26036C20.566 8.7821 20.1747 8.39079 19.6964 8.39079ZM10.9921 4.72993L13.4355 8.39079H8.54859L10.9921 4.72993ZM11.0008 15.3473C10.0442 15.3473 9.26163 14.5647 9.26163 13.6082C9.26163 12.6517 10.0442 11.8691 11.0008 11.8691C11.9573 11.8691 12.7399 12.6517 12.7399 13.6082C12.7399 14.5647 11.9573 15.3473 11.0008 15.3473Z'
    />
  );
};

export default PersonalShopperIcon;
